const Z_INDEX = {
  CONTEXT_MENU: 1150,
  COLOR_PICKER: 1150,
  TIME_PICKER: 1150,
  TOOLTIP: 1200,
  POPOVER: 1200,
  STICKY_BAR: 890,
};
const ANIMATION_PROPERTY_NAME = 'opacity';
const DEFAULT_SHOW_DURATION_ANIMATION = 275;
const DEFAULT_HIDE_DURATION_ANIMATION = 250;

export { ANIMATION_PROPERTY_NAME as A, DEFAULT_SHOW_DURATION_ANIMATION as D, Z_INDEX as Z, DEFAULT_HIDE_DURATION_ANIMATION as a };
